import type { BuildIntake, PromptForgeInput, PromptForgeResult } from "../../types";
import { uid } from "../storage";

function header(title: string): string {
  return `# ${title}\n\nGenerated by BOB Sovereign Builder v1.0 — local deterministic prompt forge.\nNo API keys required.\n\n---\n\n`;
}

function intakeBlock(intake?: BuildIntake): string {
  if (!intake) return "";
  return `## Project Context\n- **Name:** ${intake.projectName}\n- **Type:** ${intake.projectType}\n- **Target:** ${intake.targetOutput}\n- **Stack:** ${intake.stackPreference}\n- **Constraints:** ${intake.constraints || "None"}\n- **No-API paywall:** LOCKED ON\n\n`;
}

export function forgePrompt(input: PromptForgeInput, intake?: BuildIntake): PromptForgeResult {
  const intent = input.intent.trim();
  const base = header("BOB Build Directive") + intakeBlock(intake);

  let markdown = "";
  switch (input.format) {
    case "cursor":
      markdown = `${base}## Cursor Agent Pass\n\n\`\`\`\nCURSOR — BUILD PASS\n\nMISSION: ${intent}\n\nRULES:\n- Local-first / no paid API requirement\n- Preserve deploy wiring for bob.arkmpyre.com\n- Wire all visible controls to real state\n- Export handoff artifacts as MD/JSON\n\nDeliver: working surfaces, typecheck clean, verification report.\n\`\`\``;
      break;
    case "claude-code":
      markdown = `${base}## Claude Code Handoff\n\n\`\`\`markdown\n# Claude Code — BOB Implementation\n\n## Objective\n${intent}\n\n## Sovereign constraints\n- No required API keys\n- Optional adapters disabled by default\n- Deterministic local engines for grading/planning/export\n\n## Tasks\n1. Implement missing surfaces\n2. Wire buttons to real actions\n3. Run build + typecheck\n4. Produce verification report\n\`\`\``;
      break;
    case "lovable":
      markdown = `${base}## Lovable Continuation Prompt\n\nBuild B.O.B. as an operational command surface — NOT a marketing landing page.\n\n**Intent:** ${intent}\n\n**Visual:** obsidian/navy base, glass panels, gold framing, cobalt accents.\n\n**Required:** Build Intake, Repo Grader, Prompt Forge, Artifact Planner, Merge Planner, Sovereign Runtime, Export Center.\n\n**Runtime:** local-first, no API paywall, all buttons functional.\n`;
      break;
    case "local-build":
      markdown = `${base}## Local Build Prompt\n\n### Objective\n${intent}\n\n### Commands (adjust paths)\n\`\`\`bash\ncd /path/to/project\nnpm install\nnpm run typecheck\nnpm run build\n\`\`\`\n\n### Verification\n- [ ] Build succeeds offline\n- [ ] No required API keys\n- [ ] Export center downloads MD/JSON\n`;
      break;
  }

  return {
    id: uid("prompt"),
    format: input.format,
    markdown,
    createdAt: new Date().toISOString(),
  };
}
